import { createTheme } from '@mui/material/styles';

// Theme configuration based on corporate branding
export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#003064', // Corporate blue
      light: '#335682',
      dark: '#00204d',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#E19E19', // Corporate orange
      light: '#e7b047',
      dark: '#9d6e11',
      contrastText: '#000000',
    },
    grey: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#C9C9C9', // Corporate light grey
      300: '#e0e0e0',
      400: '#bdbdbd',
      500: '#9e9e9e',
      600: '#666666', // Corporate dark grey
      700: '#616161',
      800: '#424242',
      900: '#212121',
      A100: '#f5f5f5',
      A200: '#eeeeee',
      A400: '#bdbdbd',
      A700: '#616161',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    text: {
      primary: '#333333',
      secondary: '#666666', // Corporate dark grey
    },
    divider: '#C9C9C9', // Corporate light grey
  },
  typography: {
    fontSize: 13,
    fontFamily: '"Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
    h1: { fontWeight: 500 },
    h2: { fontWeight: 500 },
    h3: { fontWeight: 500 },
    h4: { fontWeight: 500 },
    h5: { fontWeight: 500 },
    h6: { fontWeight: 500 },
    button: { fontWeight: 500 },
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#003064', // Corporate blue
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 4,
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: '#00204d', // darker blue
          },
        },
        containedSecondary: {
          '&:hover': {
            backgroundColor: '#9d6e11', // darker orange
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#ffffff',
        },
      },
    },
  },
});